export var ProductInclude = {
    organization: true,
    businessUnit: true,
    children: {
        where: { deleted: false },
        include: {
            children: {
                where: { deleted: false },
            },
            businessUnit: true,
            responsible: true,
        },
    },
    parent: true,
    responsible: true,
    quantities: { where: { deleted: false } },
    tags: true,
    image: true,
    productType: true,
    massUnit: true,
};
export var ProductSelectShallow = {
    id: true,
    name: true,
    businessUnit: { select: { id: true, title: true, key: true, ancestorIds: true, active: true } },
    active: true,
    metadata: true,
    responsible: true,
    tags: true,
    externalId: true,
};
//# sourceMappingURL=Product.js.map